<template>
    <div>
        <Portal v-if="isAuthenticated">
            <Pricing :is-authenticated="isAuthenticated"/>
        </Portal>
        <PortalAuth v-else>
            <Pricing :is-authenticated="isAuthenticated"/>
        </PortalAuth>
    </div>
</template>

<script>
import Portal from "@/components/layouts/Portal.vue";
import Pricing from "@/components/Pricing.vue";
import PortalAuth from "@/components/layouts/PortalAuth.vue";
import {store} from "@/scripts/globals";

export default {
    components: {
        PortalAuth,
        Portal,
        Pricing
    },
    data() {
        return {
            isAuthenticated: false
        }
    },
    async created() {
        this.isAuthenticated = !!store.myUser;
    }
}
</script>
